<template>
  <b-row>
    <b-col>
      <b-row
        v-if="!isLoadingProject && !isLoadingTasks"
      >
        <b-col lg="3" v-if="!schedule">
          <div class="input-group input-group-sm mb-3 mb-lg-0">
            <div class="input-group-prepend">
              <label class="input-group-text">
                <small>
                  <b-icon-person-fill />
                </small>
              </label>
            </div>
            <b-select
              v-model="broker"
              :options="brokers"
              :disabled="settings.isLoadingBrokers"
              @change="filterBroker"
            />
          </div>
        </b-col>

        <b-col lg="3">
          <div class="input-group input-group-sm mb-3 mb-lg-0">
            <div class="input-group-prepend">
              <label class="input-group-text">
                <small>
                  <b-icon-search />
                </small>
              </label>
            </div>
            <b-input placeholder="Nome do cliente" v-model.trim="search" />
          </div>
        </b-col>

        <b-col
          :lg="(!this.schedule) ? '6' : '9'"
          class="d-flex align-items-center justify-content-center justify-content-lg-end"
        >
          <small class="text-muted mr-2 d-none d-lg-block">Tarefas: </small>

          <b-badge href="#" class="mr-1" variant="dark" @click="filterTasks()">
            <small>
              <b-icon-check-circle class="mr-1" v-if="!taskRange" />
            </small>
            Todas
          </b-badge>
          <b-badge href="#" class="mr-1" variant="success" @click="filterTasks('today')">
            <small>
              <b-icon-check-circle class="mr-1" v-if="taskRange === 'today'" />
            </small>
            Para hoje
          </b-badge>
          <b-badge href="#" class="mr-1" variant="danger" @click="filterTasks('past')">
            <small>
              <b-icon-check-circle class="mr-1" v-if="taskRange === 'past'" />
            </small>
            Atrasadas
          </b-badge>
          <b-badge href="#" variant="primary" @click="filterTasks('future')">
            <small>
              <b-icon-check-circle class="mr-1" v-if="taskRange === 'future'" />
            </small>
            Próximos dias
          </b-badge>

          <b-button size="sm" variant="link" @click="reloadTasks" class="p-0 ml-3">
            <small>
              <b-icon-arrow-repeat class="mr-1" />
              Atualizar
            </small>
          </b-button>
        </b-col>
      </b-row>

      <b-card no-body class="p-2 mt-2 mh-50">
        <div>
          <div
            class="d-flex justify-content-center py-4"
            v-if="isLoadingProject || isLoadingTasks"
          >
            <b-spinner variant="secondary"></b-spinner>
          </div>

          <kanban-board
            :stages="stages"
            :blocks="blocks"
            :config="config"
            @drop="onDrop"
            @init="onInit"
            v-if="!isLoadingProject && !isLoadingTasks"
          >
            <div v-for="(stage, index) in stages" :slot="stage" :key="stage" class="w-100">
              <div class="d-flex align-items-center justify-content-between">
                <h2 :class="boards[index].uid">{{ stage }}</h2>

                <small v-if="!schedule">
                  <b-icon-gear-fill
                    class="header-action text-muted"
                    @click="showBoardDetails(project.boards[index], index)"
                  />
                </small>
              </div>
            </div>

            <div
              v-for="(block, index) in blocks"
              :slot="block.id"
              :key="index"
              :class="'rounded shadow-sm bg-white block block--' + block.situation"
              @click="showCardDetails(block)"
            >
              <div class="d-flex justify-content-between align-items center p-2">
                <small>{{ block.title }}</small>

                <b-icon-exclamation-circle
                  class="text-danger"
                  v-if="block.situation === 'PAST'"
                />
              </div>

              <div class="block__footer px-2">
                <small class="text-muted assignee" :title="block.assignee" v-if="!schedule">
                  {{ block.assignee }}
                </small>

                <div>
                  <small class="text-muted dueDate">{{ block.due_date }}</small>
                </div>
              </div>
            </div>
          </kanban-board>

          <TaskModal :task="currentTask" @refresh="refresh"/>

          <b-modal
            id="edit-board"
            title="Configurar coluna"
            @hidden="reset"
          >
            <b-row>
              <b-col class="mb-2">
                <label>
                  Título <span class="text-danger">*</span>
                </label>
                <b-input v-model.trim="form.title" :disabled="isUpdatingBoard"/>
              </b-col>
            </b-row>

            <template v-slot:modal-footer>
              <b-button
                variant="outline-secondary"
                size="sm"
                :disabled="false"
                @click="close()"
              >
                Cancelar
              </b-button>
              <CRMButton
                label="Salvar"
                variant="primary"
                size="sm"
                :loading="isUpdatingBoard"
                :disabled="isInvalid"
                @click="save()"
              />
            </template>
          </b-modal>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex';
import DateParser from '@/parsers/date';
import TaskModal from '@/components/Projects/TaskModal.vue';
import CRMButton from '@/components/CRMButton/CRMButton.vue';
import { ProjectsService } from '@/services';

export default {
  components: {
    TaskModal,
    CRMButton,
  },

  props: [
    'isLoadingProject',
    'isLoadingTasks',
    'teamSlug',
    'boards',
    'tasks',
    'info',
    'schedule',
  ],

  data() {
    return {
      taskRange: null,
      broker: null,
      search: '',
      currentTask: {},
      lockedBoards: [],
      isUpdatingBoard: false,
      form: {
        uid: null,
        title: '',
      },
      config: {
        accepts(el, target, source) {
          if (!target || !source || (target === source)) {
            return false;
          }

          return true;
        },
        // moves(el, source) {
        //   const sourceOrder = context.getBoardOrderByStatus(source.dataset.status);

        //   return sourceOrder !== context.stages.length;
        // },

        // accepts(block, target, source) {
        //   const targetOrder = context.getBoardOrderByStatus(target.dataset.status);
        //   const sourceOrder = context.getBoardOrderByStatus(source.dataset.status);

        //   context.lockBoards(sourceOrder, targetOrder);

        //   return targetOrder === sourceOrder + 1;
        // },
      },
    };
  },

  created() {
    this.$store.dispatch('settings/fetchBrokers', {
      companyId: this.user.company_id,
      teamSlug: this.teamSlug,
    });
  },

  computed: {
    ...mapState(['settings']),

    project() {
      return {
        boards: this.boards,
        tasks: this.tasks,
      };
    },

    stages() {
      if (this.boards) {
        return this.boards.map((board) => board.title);
      }

      return [];
    },

    blocks() {
      return this
        .tasks
        .filter((task) => ((this.taskRange) ? task.situation === this.taskRange : true))
        .filter((task) => {
          if (!this.search) {
            return true;
          }

          return task.title.toLowerCase().includes(this.search.toLowerCase());
        })
        .map(this.parseTaskToBlocks.bind(this));
    },

    brokers() {
      return [
        { text: 'Todos', value: null },
        ...this
          .settings
          .brokers
          .map((broker) => ({
            text: `${broker.first_name} ${broker.last_name}`,
            value: broker.uid,
          })),
      ];
    },

    isInvalid() {
      return this.form.title === '';
    },
  },

  methods: {
    onInit(drake) {
      /* TODO: Fix this taskRange solution */
      this.taskRange = 'past';
      this.taskRange = null;

      this.drake = drake;
      this.containerEls = drake.containers;
    },

    filterTasks(filter = null) {
      this.taskRange = filter;
    },

    filterBroker() {
      this.$emit('change-broker', this.broker);
    },

    parseTaskToBlocks(task) {
      const status = this.boards
        .filter((board) => board.uid === task.board_id)
        .pop()
        .title;

      return {
        status,
        id: task.uid,
        title: task.title,
        created_at: task.created_at,
        due_date: task.due_date,
        assignee: task.assignee,
        assignee_id: task.assignee_id,
        situation: task.situation,
        client_id: task.client_id,
      };
    },

    getBoardOrderByStatus(status) {
      return this
        .boards
        .filter((board) => board.title === status)
        .pop()
        .order;
    },

    lockBoards(sourceBoard) {
      this.lockedBoards = this
        .boards
        .filter((board) => board.order < sourceBoard || board.order > (sourceBoard + 1))
        .map(({ title }) => title);
    },

    onDrop(block, list) {
      const { blockId } = block.dataset;
      const { status } = list.dataset;

      const boardId = this
        .boards
        .filter((board) => board.title === status)
        .pop()
        .uid;

      this.$store.dispatch('projects/updateTask', { id: blockId, board_id: boardId });
      /* TODO: Update project tasks */
    },

    showCardDetails(task) {
      this.$store.dispatch('task/setTaskDetails', task);

      this.$bvModal.show('task-details');
    },

    isDelayed(date) {
      return DateParser.isBeforeToday(date);
    },

    getTaskSituation(date) {
      if (!date) {
        return 'unknown';
      }

      const formatted = DateParser.parseFromTimestamp(date.seconds);

      if (DateParser.isBeforeToday(formatted)) {
        return 'past';
      }

      if (DateParser.isAfterToday(formatted)) {
        return 'future';
      }

      return 'today';
    },

    reloadTasks() {
      this.$emit('reload-tasks', { brokerId: this.broker });
    },

    refresh(task) {
      /* TODO: Update project tasks */
      const taskObj = this.blocks.find((item) => item.id === task.id);
      const card = document.querySelector(`[data-block-id="${task.id}"] .block`);

      if (task.due_date) {
        const date = DateParser.parseFromTimestamp(task.due_date.seconds);
        const situation = this.getTaskSituation(task.due_date);

        taskObj.due_date = date;
        taskObj.situation = situation;

        card.querySelector('.dueDate').innerHTML = date;

        card.classList.remove('block--unknown', 'block--past', 'block--today', 'block--future');
        card.classList.add(`block--${situation}`);
      }

      if (task.assignee) {
        taskObj.assignee = task.assignee;
        taskObj.assignee_id = task.assignee_id;

        card.querySelector('.assignee').innerHTML = task.assignee;
      }
    },

    showBoardDetails(board, index) {
      this.form.index = index;
      this.form.uid = board.uid;
      this.form.title = board.title;
      this.$bvModal.show('edit-board');
    },

    close() {
      this.$bvModal.hide('edit-board');
      this.reset();
    },

    async save() {
      this.isUpdatingBoard = true;

      try {
        await ProjectsService.updateBoardById(this.form.uid, { ...this.form });
        await this.$store.dispatch('projects/updateBoard', { ...this.form });

        this.$store.commit('global/SET_NOTIFICATION', {
          variant: 'success',
          content: 'Coluna configurada com sucesso',
          title: 'Sucesso!',
        }, { root: true });

        document
          .querySelector(`.${this.form.uid}`)
          .innerHTML = this.form.title;

        // this.stages.splice(this.form.index, 1, this.form.title);

        // this.blocks = this.blocks.map((block) => {
        //   if (block.board_id === this.form.uid) {
        //     return { ...block, status: this.form.title };
        //   }

        //   return block;
        // });

        this.close();
      } catch (err) {
        console.log(err);
        this.$store.commit('global/SET_NOTIFICATION', {
          variant: 'danger',
          content: 'Não foi possível configurar a coluna',
          title: 'Ops! Encontramos um problema',
        }, { root: true });
      }

      this.isUpdatingBoard = false;
    },

    reset() {
      this.form.index = null;
      this.form.title = '';
      this.form.title = '';
    },
  },
};
</script>

<style lang="scss">
  .drag {
    &-container {
      max-width: 100%;
      height: 77vh;
      overflow: auto;
    }

    &-list,
    &-inner-list {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    &-list {
      align-items: flex-start;
      display: flex;
      justify-content: space-between;

      @media (max-width: 690px) {
        display: block;
      }
    }

    &-column {
      background: #e9ecef;
      border-radius: .25rem;
      flex: 1;
      position: relative;
      margin: 0;
      padding: 10px;
      overflow: hidden;
      min-width: 210px;
      width: 100%;

      &:not(:last-child) {
        margin: 0 1.25rem 0 0;
      }

      h2 {
        font-size: .8rem;
        font-weight: 600;
        margin: 0;
        text-transform: uppercase;
      }

      &-header {
        align-items: center;
        display: flex;
        justify-content: space-between;
        margin: 0 0 10px;

        .header-action {
          transition: fill .15s ease-out;

          &:hover {
            cursor: pointer;
            fill: #007bff;
          }
        }
      }

      .board-blocked {
        align-items: center;
        background: rgba(233, 236, 239, .75);
        color: #d32f2f;
        display: flex;
        font-size: 2em;
        height: 100%;
        justify-content: center;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: 2;
      }
    }

    &-inner-list {
      min-height: 50px;
    }

    &-item {
      touch-action: none;
      transition: box-shadow .15s ease-out, transform .15s ease-out;

      .block {
        border-left: 4px solid #6c757d;

        &--past {
          border-color: #dc3545;
        }

        &--today {
          border-color: #28a745;
        }

        &--future {
          border-color: #007bff;
        }

        &__footer {
          align-items: center;
          background: rgba(249, 249, 249, .8);
          border-top: 1px solid rgba(0, 0, 0, .125);
          display: flex;
          font-size: .875em;
          justify-content: space-between;

          .assignee {
            display: inline-block;
            max-width: 50%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }

      &:not(:last-child) {
        margin: 0 0 5px;
      }

      &:hover {
        box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15);
        cursor: move;
        cursor: grab;
        cursor: -moz-grab;
        cursor: -webkit-grab;
      }

      &.is-moving {
        box-shadow: 0 1rem 3rem rgba(0, 0, 0, .175);
        cursor: grabbing;
        cursor: -moz-grabbing;
        cursor: -webkit-grabbing;
      }
    }
  }

  .gu {
    &-mirror {
      list-style-type: none;
      margin: 0 !important;
      opacity: 0.8;
      position: fixed !important;
      z-index: 9999 !important;
    }

    &-hide {
      display: none !important;
    }

    &-unselectable {
      -webkit-user-select: none !important;
      -moz-user-select: none !important;
      -ms-user-select: none !important;
      user-select: none !important;
    }

    &-transit {
      opacity: .3;
    }
  }
</style>
